import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Styled from 'page404_styled';
import { updateApplicantWotcCheckStatus } from '../../../api/api';

const ApplicantNotification = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedIntegrationID = params.get('integrationID');

    if (!encodedIntegrationID) {
      // No API call if missing
      return;
    }

    updateApplicantWotcCheckStatus(
      encodedIntegrationID,
      window.activeEnvironment,
    ).catch(() => {});
    // Ignore API result, always show thank you
  }, [location.search]);

  return (
    <Styled.Container404>
      <Styled.MessageContainer>
        <Styled.UnknownTitle>Thank you!</Styled.UnknownTitle>
      </Styled.MessageContainer>
    </Styled.Container404>
  );
};

export default ApplicantNotification;
